module.exports = __webpack_public_path__ + "static/media/Products (12).a82248d6.png";